<template>
  <div class="customer-single-report">
    <div class="search">
      <div class="statistics">
        <div class="statistice-container">
          <span>客户名称：</span>
          <span class="black-grey">{{ customerName }}</span>
        </div>
        <div class="statistice-container">
          <span>出库单量：</span>
          <span class="black-grey">{{ outboundNum }}</span>
        </div>
        <div class="statistice-container">
          <div>
            <span>收入金额：</span>
            <span class="gross-profit">{{ totalAmount }}</span>
          </div>
          <p class="difference">
            保底差额：{{difference}}
          </p>
        </div>
        <div class="statistice-container">
          <span>成本金额：</span>
          <span class="gross-profit">{{ totalCost }}</span>
        </div>
      </div>
    </div>

    <div class="table table-main">
      <div class="table-container">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
          class="ss"
          v-for="(item, index) in tableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width">
            <template slot-scope="scope">
              <div :class="(item.prop == 'taxIncludedAmount' || item.prop == 'cost')?'table-content':''">
                <span class="item-title" :class="scope.row[item.prop] < 0 ? 'hign-red':''">{{scope.row[item.prop]}}</span>
                <div class="img-container">
                  <img
                    class="taxInclude-cost mod"
                    src="../../../../assets/images/operate/mod.png" 
                    v-if="((item.prop == 'taxIncludedAmount' || item.prop == 'cost')  && scope.row.dataType == 1)" 
                    @click="modTaxIncludedAmountOrCost(scope.row, item.prop)"
                  >
                  <img
                    class="taxInclude-cost history"
                    src="../../../../assets/images/operate/history.png" 
                    v-if="
                      ((item.prop == 'taxIncludedAmount' && scope.row.dataType == 1 && scope.row.incomeHistoryFlag == 1) ||
                      (item.prop == 'cost' && scope.row.costHistoryFlag == 1))
                    " 
                    @click="lookHistoricalRecordsList(scope.row, item.prop)"
                  >
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="foot">
      <el-button class="btn-white" @click="goBack">返回</el-button>
    </div>

    <!-- 编辑 -->
    <el-dialog title="编辑" top="15vh" :visible.sync="modCostOrIncomeDialog" width="420px">
      <div class="border"></div>
      <el-form
        ref="modCostOrIncomeForm"
        :model="modCostOrIncomeForm"
        label-width="100px"
      >
        <el-form-item v-if="isTaxIncludedAmountOrCost == 1" label="收入金额：" prop="income">
          <el-input
            v-model="modCostOrIncomeForm.income"
            class="white cost"
            @input="incomeInput(modCostOrIncomeForm.income)"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item v-else label="成本金额：" prop="cost">
          <el-input
            v-model="modCostOrIncomeForm.cost"
            class="white cost"
            @input="costInput(modCostOrIncomeForm.cost)"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remarks">
          <el-input type="textarea" v-model="modCostOrIncomeForm.remarks" resize="none" class="white" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="submit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 历史记录 -->
    <el-dialog title="历史记录" top="15vh" :visible.sync="historicalRecordsDialog" width="820px" :before-close="handleClose">
      <div class="border"></div>
      <div class="table">
        <el-table :data="historicalRecordsList" style="width: 100%" height="500px">
          <el-table-column
          v-for="(item, index) in historicalRecordsTitle"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :show-overflow-tooltip="item.showOverflowTooltip"
          :min-width="item.width">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { inputAllTwoDecimal, formaTimeToAllSecond } from "common/js/util";
import { getDBUserRealName } from "common/js/storage";
import Operate from "models/operate.js";
export default {
  data() {
    return {
      username: '',
      projectId: '',
      date: '',
      /* 1、账单中的费用类型都属于第一项 2、其他成本 */
      dataType: '',
      customerName: '',
      outboundNum: '',
      totalAmount: '',
      // 保底差额
      difference: '',
      totalCost: '',
      tableData: [],
      tableTitleList: [
        {prop: 'feeType', label: '费用类型', width: ''},
        {prop: 'detailName', label: '明细名称', width: ''},
        {prop: 'value', label: '数值', width: ''},
        {prop: 'taxIncludedAmount', label: '收入金额', width: ''},
        {prop: 'cost', label: '成本金额', width: ''},
        {prop: 'grossProfit', label: '总毛利', width: ''},
        {prop: 'unitGrossProfit', label: '单位毛利', width: ''},
        {prop: 'unWeighedNum', label: '未称重单量', width: ''},
      ],
      modCostOrIncomeDialog: false,
      modCostOrIncomeForm: {
        id: '',
        income: '',
        cost: '',
        remarks: ''
      },
      /* 1: 收入金额；2: 成本金额 */
      isTaxIncludedAmountOrCost: 1,
      historicalRecordsDialog: false,
      historicalRecordsList: [],
      historicalRecordsTitle: [
        {showOverflowTooltip: false,prop: 'createTime', label: '时间', width: '120'},
        {showOverflowTooltip: false,prop: 'operator', label: '操作员', width: ''},
        {showOverflowTooltip: false,prop: 'before', label: '上次金额', width: ''},
        {showOverflowTooltip: false,prop: 'after', label: '本次金额', width: ''},
        {showOverflowTooltip: true,prop: 'remarks', label: '备注', width: '200'},
      ]
    };
  },
  created() {
    this.projectId = this.$route.query.id
    this.date = this.$route.query.date
    this.username = getDBUserRealName();
    this.getTableData()
  },
  methods: {
    //获取客户单报
    getTableData() {
      let date = this.date
      let projectId = this.projectId
      Operate
        .getCustomerSingleReport(projectId, date)
        .then(res => {
          if (res.success) {
            let { customerName, outboundNum, totalAmount, totalCost, feeDetailList, difference, otherCostDetailList} = res.result
            this.customerName = customerName
            this.outboundNum = outboundNum
            this.totalAmount = totalAmount
            this.difference = difference
            this.totalCost = totalCost
            this.tableData = [...feeDetailList, ...otherCostDetailList];
          } else {
            this.$message.error(res.message);
          }
        });
    },

    modTaxIncludedAmountOrCost(row, type) {
      if (type == 'taxIncludedAmount') {
        this.isTaxIncludedAmountOrCost = 1
        this.modCostOrIncomeForm.income = row.taxIncludedAmount
      } else {
        this.isTaxIncludedAmountOrCost = 2
        this.modCostOrIncomeForm.cost = row.cost
      }
      this.dataType = row.dataType
      this.modCostOrIncomeForm.id = row.id
      this.modCostOrIncomeDialog = true
    },

    incomeInput(v) {
      this.modCostOrIncomeForm.income = inputAllTwoDecimal(v);
    },

    costInput(v) {
      this.modCostOrIncomeForm.cost = inputAllTwoDecimal(v);
    },

    closeDialog() {
      this.modCostOrIncomeForm.id = ''
      this.modCostOrIncomeForm.income = ''
      this.modCostOrIncomeForm.cost = ''
      this.modCostOrIncomeForm.remarks = ''
      this.modCostOrIncomeDialog = false
    },

    submit() {
      let operator = this.username
      let id = this.modCostOrIncomeForm.id;
      let remarks = this.modCostOrIncomeForm.remarks;
      let income = this.modCostOrIncomeForm.income
      let cost = this.modCostOrIncomeForm.cost
      let dataType = this.dataType
      let date = this.date
      let data = {
        id,
        remarks,
        operator,
        dataType,
      }
      if (this.dataType == 2) data.date = date
      if (this.isTaxIncludedAmountOrCost == 1) {
        data.income = income
        this.modIncome(data)
      } else {
        data.cost = cost
        this.modCost(data)
      }
    },

    /* 编辑收入金额 */
    modIncome(data) {
      Operate.postModIncome(data).then(res => {
        if (res.success) {
          this.getTableData();
          this.closeDialog()
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 编辑成本金额 */
    modCost(data) {
      Operate.postModCost(data).then(res => {
        if (res.success) {
          this.getTableData();
          this.closeDialog()
        } else {
          this.$message.error(res.message);
        }
      });
    },

    lookHistoricalRecordsList(row, v) {
      let id = row.id
      let dataType = row.dataType
      let type = v == 'taxIncludedAmount' ? 1 : 2
      let date = this.date
      Operate
        .getHistoricalRecordsList(id, type, dataType, date)
        .then(res => {
          if (res.success) {
            let arr = []
            res.result.map(i => {
              let obj = {}
              obj.createTime = formaTimeToAllSecond(i.createTime)
              obj.operator = i.operator
              obj.before = i.before
              obj.after = i.after
              obj.remarks = i.remarks
              arr.push(obj)
            })
            this.historicalRecordsList = arr;
            this.historicalRecordsDialog = true
          } else {
            this.$message.error(res.message);
          }
        });
    },

    handleClose() {
      this.historicalRecordsDialog = false
    },

    goBack() {
      this.$router.go(-1)
    }
  }
};
</script>
<style lang="scss" scoped>
.customer-single-report {
  flex: 1;
  .search {
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;
    .statistics {
      width: 100%;
      height: 96px;
      background: #F8FAFB;
      border-radius: 4px 4px 0px 0px;
      display: flex;
      justify-content: space-around;
      margin-bottom: 20px;
      font-size: 18px;
      font-weight: 400;
      color: #666666;
    }
    .statistice-container {
      padding-top: 38px;
    }
    .black-grey {
      color: #333333;
    }
    .gross-profit {
      color: #2E68EA;
    }
    .difference {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      line-height: 24px;
    }
    .el-select {
      margin-right: 16px;
    }
    .btn-blue {
      margin: 0;
    }
    .paddingRight {
      margin-right: 16px;
    }
  }
  .table {
    background: #fff;
    border-radius: 4px;
    .hign-red {
      color: #FF0909;
    }
    .table-content {
      display: flex;
      .img-container {
        width: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .item-title {
        min-width: 80px;
        display: inline-block;
        text-align: right;
      }
    }
    .taxInclude-cost {
      margin-left: 10px;
      cursor: pointer;
    }
    .mod {
      width: 14px;
      height: 14px;
    }
    .history {
      width: 15px;
      height: 16px;
    }
    .totle-price {
      height: 48px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      padding: 0px 16px;
      border-bottom: 1px solid #eee;
      p {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
      }
    }
    .table-container {
      padding: 16px;
    }
    .el-table {
      .cell {
        position: relative;
        .remarks {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-right: 14px;
        }
        .icon {
          position: absolute;
          right: 1px;
          top: 9px;
          cursor: pointer;
        }
      }
    }
  }
  .foot {
    // position: absolute;
    // bottom: 0px;
    // left: 0px;
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
<style lang="scss">
.customer-single-report {
  .table {
    .el-table {
      .el-input {
        .el-input__inner {
          height: 24px;
          padding-left: 5px;
          padding-right: 0px;
        }
      }
    }
  }
  .table-main .el-table .el-table__header-wrapper .el-table__header tr th:nth-of-type(4),
  .table-main .el-table .el-table__header-wrapper .el-table__header tr th:nth-of-type(5) {
    .cell {
      padding-left: 50px;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }
}
</style>